
const StatsCard = ({
  title1,
  value1,
  icon1:Icon1,
  title2,
  value2,
  icon2:Icon2,
  title3,
  value3,
  icon3:Icon3,
  title4,
  value4,
  icon4:Icon4,
}) => {
  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        {/* Total  */}
        <div className="bg-purple-100 border border-purple-200 rounded-xl p-4 shadow-xl flex items-center gap-4 transform hover:scale-[1.02] transition-transform duration-300">
          <div className="p-3 bg-purple-200 rounded-lg">
            {Icon1 && <Icon1 className="text-purple-600 text-xl" />}
          </div>
          <div>
            <p className="text-purple-800 text-md font-medium">{title1}</p>
            <h2 className="text-2xl font-semibold text-purple-900">{value1}</h2>
          </div>
        </div>

        {/* Departments */}
        <div className="bg-blue-100 border border-blue-200 rounded-xl p-4 shadow-xl flex items-center gap-4 transform hover:scale-[1.02] transition-transform duration-300">
          <div className="p-3 bg-blue-200 rounded-lg">
            {Icon2 && <Icon2 className="text-blue-600 text-xl" />}
          </div>
          <div>
            <p className="text-blue-800 text-md font-medium">{title2}</p>
            <h2 className="text-2xl font-semibold text-blue-900">{value2}</h2>
          </div>
        </div>

        {/* Active  */}
        <div className="bg-green-100 border border-green-200 rounded-xl p-4 shadow-xl flex items-center gap-4 transform hover:scale-[1.02] transition-transform duration-300">
          <div className="p-3 bg-green-200 rounded-lg">
            {Icon3 && <Icon3 className="text-green-600 text-xl" />}
          </div>
          <div>
            <p className="text-green-800 text-md font-medium">{title3}</p>
            <h2 className="text-2xl font-semibold text-green-900">{value3}</h2>
          </div>
        </div>

        {/* Inactive  */}
        <div className="bg-red-100 border border-red-200 rounded-xl p-4 shadow-xl flex items-center gap-4 transform hover:scale-[1.02] transition-transform duration-300">
          <div className="p-3 bg-red-200 rounded-lg">
            {Icon4 && <Icon4 className="text-red-600 text-xl" />}
          </div>
          <div>
            <p className="text-red-800 text-md font-medium">{title4}</p>
            <h2 className="text-2xl font-semibold text-red-900">{value4}</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
